import { render, staticRenderFns } from "./StaffUploadEvaluators.vue?vue&type=template&id=213d116a&scoped=true&"
import script from "./StaffUploadEvaluators.vue?vue&type=script&lang=js&"
export * from "./StaffUploadEvaluators.vue?vue&type=script&lang=js&"
import style0 from "./StaffUploadEvaluators.vue?vue&type=style&index=0&id=213d116a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d116a",
  null
  
)

export default component.exports